// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__19Dk9","productName":"Table_productName__fP1hM"};